import { memo, useMemo } from 'react'

import SC from 'styled-components'

import { Select } from '../Select'

interface Props {
  sizeOptions?: string[]
  size: number
  changeSize: (size: number) => void
  disabled?: boolean
}

const Content = SC.div<any>`
  margin: 0 0 0 10px;
`

const sizeDefault = ['10', '20', '50', '100']

export const Options = memo((props: Props) => {
  const { size, sizeOptions = sizeDefault, changeSize, disabled } = props
  const getSizeOptions = useMemo(() => {
    if (sizeOptions.some((option) => option.toString() === size.toString())) {
      return sizeOptions
    }
    return sizeOptions.concat([size.toString()]).sort((a, b) => {
      const numberA = isNaN(Number(a)) ? 0 : Number(a)
      const numberB = isNaN(Number(b)) ? 0 : Number(b)
      return numberA - numberB
    })
  }, [size, sizeOptions])
  const onChangeSize = (value: string) => changeSize(Number(value))
  return (
    <Content>
      <Select
        value={(size || getSizeOptions[0]).toString()}
        onChange={onChangeSize}
        disabled={disabled}
        data={getSizeOptions.map((value) => ({ label: value, value }))}
      />
    </Content>
  )
})
